import React, { useRef } from 'react';
import style from './add-intent.module.scss';
import { Modal } from '../../../components';
import { entity } from './constants';

type Props = {
	onOk: () => void;
	onCancel: () => void;
	isOpen: boolean;
	onEntityNameChange: (intent: string) => void;
	initialEntityName?: string;
	isEdit?: boolean;
	loading?: boolean;
	error: string;
};

export function AddEntity(props: Props) {
	const inputRef = useRef(null);
	const {
		onOk,
		onCancel,
		isOpen,
		onEntityNameChange,
		initialEntityName = '',
		isEdit = false,
		loading = false,
		error,
	} = props;

	return (
		<Modal
			onOk={onOk}
			okText={isEdit ? 'Update' : 'Submit'}
			onCancel={onCancel}
			isOpen={isOpen}
			title={isEdit ? 'Edit Entity' : 'Add Entity'}
			loading={loading}
		>
			<div className={style.addIntentContent}>
				<p>
					{entity.title}
				</p>
				<p className={style.green} style={{ marginBottom: 0 }}>
			    {entity["sub-text-1"]}
				</p>
				<p className={style.green}>
			    {entity["sub-text-2"]}
				</p>
				<p>
					In these utterances, <span>pizza</span> would be categorized under the{' '}
					<span>FoodItem</span> entity, <span>dinner</span> and{' '}
					<span>tonight</span> would fall under the <span>time</span> entity,
					and <span>large</span> and <span>pepperoni</span> would be details for{' '}
					<span>size</span> and <span>type</span> entities, respectively.
				</p>
				<div className={style.Form}>
					<label htmlFor="entityName">Entity Name</label>
					<input
						onKeyDown={(e) => {
							if (e.keyCode === 13) {
								onOk();
							}
						}}
						ref={inputRef}
						autoFocus
						defaultValue={initialEntityName}
						onChange={(e) => {
							onEntityNameChange(e.target.value);
						}}
						id="entityName"
						placeholder="Enter entity name"
					/>
					{error && <span className={style.error}>{error}</span>}
				</div>
			</div>
		</Modal>
	);
}
